import React from 'react';
import {Switch, Route} from 'react-router-dom';

import UserTab from './UserTab';
import UserGroupTab from './UserGroupTab';

function UserScreen() {
  return (
    <Switch>
      <Route path="/users/groups" component={UserGroupTab} />
      <Route path="/users" component={UserTab} />
    </Switch>
  );
}

export default UserScreen;
